import React from "react";

import { get } from "../utils";

import en from "./en.yaml";
import nl from "./nl.yaml";
import fr from "./fr.yaml";
import enHelp from "./help/en.yaml";
import nlHelp from "./help/nl.yaml";
import frHelp from "./help/fr.yaml";
import enCodes from "./codes/en.yaml";
import nlCodes from "./codes/nl.yaml";
import frCodes from "./codes/fr.yaml";

import { getCurrentLanguage } from "../LanguageHelper";
import { useParams } from "react-router-dom";

export const locales = {
  en: { ...en, HELP: enHelp, CODES: enCodes },
  nl: { ...nl, HELP: nlHelp, CODES: nlCodes },
  fr: { ...fr, HELP: frHelp, CODES: frCodes },
};
//language code https://www.wikiwand.com/en/List_of_ISO_639-1_codes
export const translate = (ISO639_1) => (keys, args) => {
  const path = [ISO639_1].concat(keys);
  const template = get(path, locales);
  try {
    if (!template) {
      // if path is something like 'en' - 'CODES' - ... it means we don't handle that kind of code.
      if (path.length > 2 && path[1] === 'CODES') {
        return '';
      }
      throw Error(`No template ${keys}`);
    }
    return template.replace(/\${([^}]*)}/g, (wholeMatch, name) => args[name]);
  } catch (error) {
    console.error(error);
    return template
      ? "*Interpolation error* " + path
      : "*Missing translation* " + path;
  }
};

export const hasTranslation = (ISO639_1) => (keys) =>
  !!get([ISO639_1].concat(keys), locales);

export const i18nHOC = (Component) => (props) => {
  const { lang } = useParams();
  return (
    <Component
      {...props}
      i18n={translate(getCurrentLanguage({ params: { lang } }))}
      lang={getCurrentLanguage({ params: { lang } })}
    />
  );
};

const convertKeysToKebabCase = (keys) =>
  [].concat(keys).join("-").replace(/\s+/g, "-").toLowerCase();

/**
 * Create a span element containing the translation corresponding to keys.
 * @param {{keys:string|Array<string>,args:Array,style:*}} props 
 * @returns Corresponding translation wrapped in span
 */
const I18n = ({ keys, args, style }) => {
  const { lang } = useParams();
  return (
    <span data-test={convertKeysToKebabCase(keys)} style={style}>
      {translate(getCurrentLanguage({ params: { lang } }))(keys, args)}
    </span>
  );
};

export default I18n;
